import { render, staticRenderFns } from "./DocumentChip.vue?vue&type=template&id=f0ca58c2&scoped=true&"
import script from "./DocumentChip.vue?vue&type=script&lang=js&"
export * from "./DocumentChip.vue?vue&type=script&lang=js&"
import style0 from "./DocumentChip.vue?vue&type=style&index=0&id=f0ca58c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ca58c2",
  null
  
)

export default component.exports